import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    height: '150',
    overflow: 'visible',
    border: 'none',
    // Sit flat on the page; an opaque white card would also cut a visible edge
    // into the sticky header's drop shadow.
    backgroundColor: 'transparent',
    borderRadius: 12,
    boxShadow: 'none',
  },
  disableSpacing: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  },
  coachAvatar: {
    border: '2px solid rgb(255, 255, 255)',
    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 1px 1px',
    width: '110px',
    height: '110px',
    marginTop: '0.25rem',
    fontSize: '2.5rem',
    color: '#fff',
    backgroundColor: '#d8d8d8',
    [theme.breakpoints.down('sm')]: {
      marginRight: `${theme.spacing(0)} !important`,
      marginBottom: theme.spacing(2),
    },
  },
  profile: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
    },
  },
  coachInfo: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '10rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  coachTitle: {
    display: 'block',
    color: theme.palette.secondary.dark,
    fontWeight: 700,
    fontSize: '1rem',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(1),
    },
  },
  profileCaption: {
    display: 'block',
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '1rem',
    marginTop: theme.spacing(1.25),
    paddingLeft: '2px',
    paddingBottom: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0.5),
      paddingLeft: 0,
    },
  },
  infoWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& h4': {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        marginBottom: theme.spacing(1),
      },
    },
  },
  logoWrapper: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'unset',
    },
  },
}))
